import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import colors from "Utils/colors";
import dayjs from "dayjs";
import { tideStationsGreenland } from "Utils/globals";
import DropDownMenu from "Molecules/DropDownMenu";
import CircularProgress from "@mui/material/CircularProgress";
import * as Highcharts from "highcharts";
import "highcharts/modules/accessibility";
const { dmiBlue, dmiBlack } = colors;

const options = {
  palette: {
    colorScheme: "light",
  },
  title: {
    text: "",
    align: "left",
    margin: 24,
    style: {
      fontSize: "18px",
      fontWeight: "bold",
      color: dmiBlack,
    },
  },
  subtitle: {
    useHTML: true,
    text: "Tidspunkter i Grønlandsk Normaltid (UTC-2 timer)<br>Reference til middelvandstand (MSL)",
    align: "left",
    verticalAlign: "bottom",
    style: {
      fontSize: "16px",
      color: dmiBlack,
    },
  },
  exporting: {
    enabled: false,
  },
  chart: {
    height: 450,
    spacing: [24, 24, 24, 24],
    animation: false,
    zooming: {
      type: "x",
    },
    panning: true,
    panKey: "shift",
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    series: {
      animation: false,
      grouping: false,
    },
  },
  tooltip: {
    valueDecimals: 1,
    valueSuffix: " cm",
    dateTimeLabelFormats: {
      hour: "%a %d. %b %Y %H:%M",
      minute: "%a %d. %b %Y %H:%M",
    },
  },
  xAxis: {
    type: "datetime",
    dateTimeLabelFormats: {
      day: "%a %e. %b",
    },
  },
  legend: {
    enabled: true,
  },
  yAxis: {
    title: {
      text: "",
    },
  },
  series: [
    {
      name: "Tidevand",
      data: [],
      type: "spline",
      marker: {
        enabled: false,
      },
      color: dmiBlue,
    },
  ],
};

const base_url = "https://opendataapi.dmi.dk/v2/oceanObs/collections/tidewater";
const narrowScreen = screen.width < 500;

const Tides = ({ stationId, stationName, noDropdown }) => {
  const chartRef = useRef(null);
  const [station, setStation] = useState(
    stationId ?? tideStationsGreenland[0].key
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const getData = () => {
      const from = dayjs().toISOString();
      const to = dayjs()
        .add(narrowScreen ? 3 : noDropdown ? 10 : 31, "day")
        .toISOString();

      const url =
        `${base_url}/items?predictionType=10minutes&limit=10000` +
        `&datetime=${from}/${to}&stationId=${station}`;

      // Reset graph
      chartRef?.current?.chart.series[0].update({ data: [] });
      chartRef?.current?.chart.yAxis[0].removePlotLine("lat");
      chartRef?.current?.chart.setTitle({ text: stationName });
      setLoading(true);

      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          if (cancelled) {
            return;
          }
          setLoading(false);
          const ar = [];
          data?.features.forEach((item) => {
            const d = new Date(item.properties.predictionTime);
            // Times in UTC - 2 hours
            ar.push([d.getTime() - 2 * 3600 * 1000, item.properties.value]);
          });

          chartRef?.current?.chart.series[0].update({
            data: ar.sort((a, b) => a[0] - b[0]),
          });

          chartRef?.current?.chart.yAxis[0].addPlotLine({
            value: tideStationsGreenland.find((item) => item.key === station)
              ?.lat,
            color: "green",
            dashStyle: "shortdash",
            width: 2,
            label: {
              text: "LAT",
              align: "right",
            },
            id: "lat",
          });
        })
        .catch((err) => {
          if (!cancelled) {
            setLoading(false);
            console.log(err);
          }
        });
    };
    getData();
    return () => {
      cancelled = true;
    };
  }, [station, noDropdown, stationName]);

  useEffect(() => {
    setStation(stationId);
  }, [stationId]);

  return (
    <div>
      <h3>Tidevand</h3>
      <div className={noDropdown ? "" : "rounded-shadow"}>
        {!noDropdown && (
          <div
            className="graph-selectors"
            style={{ backgroundColor: "white", padding: "24px" }}
          >
            <DropDownMenu
              options={tideStationsGreenland}
              value={station}
              label="Vælg målestation"
              disabledLabel="Vælg målestation"
              onChange={(e) => setStation(e.target.value)}
            />
          </div>
        )}
        {loading && (
          <div style={{ backgroundColor: "white", padding: "24px" }}>
            <CircularProgress />
          </div>
        )}
        <HighchartsReact
          highcharts={Highcharts}
          ref={chartRef}
          options={options}
        />
      </div>
      {!narrowScreen && (
        <i style={{ float: "left", fontSize: "12px" }}>
          zoom: klik og træk med musen, panorering: shift + klik og træk med
          musen
        </i>
      )}
    </div>
  );
};

export default Tides;
